import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { CampusLocationFilterComponent } from './campus-location-filter.component'
import { SharedModule } from '../shared/shared.module'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'



@NgModule({
  declarations: [CampusLocationFilterComponent],
  imports: [
    CommonModule,
    SharedModule,
    FormsModule,
    ReactiveFormsModule
  ],
  exports: [CampusLocationFilterComponent]
})
export class CampusLocationFilterModule { }
